// extracted by mini-css-extract-plugin
module.exports = {"location":"_3zo99"};